import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { AuthUser } from '../api/auth.api';

/**
 * Business-oriented auth actions. Navigation happens only on Login/Logout
 * Success — never on Login Failure (failures stay on the auth screen).
 */
export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: props<{ email: string; password: string }>(),
    // Google Workspace sign-in — the only login path exposed in the UI.
    'Google Login': emptyProps(),
    'Login Success': props<{ user: AuthUser; tenantId: string }>(),
    'Login Failure': props<{ error: string }>(),

    Logout: emptyProps(),
    'Logout Success': emptyProps(),

    'Restore Session': emptyProps(),
    'Restore Session Success': props<{ user: AuthUser | null; tenantId: string | null }>(),
  },
});
